import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { ElectricUtilityProduct } from '@intellio/shared/models';
import { AppConfigService } from './app-config.service';
import { AuthService } from './auth.service';
import { BaseService } from './base-service.service';

@Injectable({
  providedIn: 'root',
})
export class ElectricUtilityProductService extends BaseService {
  private readonly baseUrl = '/api/electricutilityproducts';

  constructor() {
    const client = inject(HttpClient);
    const configService = inject(AppConfigService);
    const authService = inject(AuthService);

    super(client, configService, authService);
  }

  getElectricUtilityProducts() {
    return this.get<ElectricUtilityProduct[]>(this.baseUrl);
  }

  getElectricUtilityProduct(rateCode: string) {
    return this.get<ElectricUtilityProduct>(
      `${this.baseUrl}/${encodeURIComponent(rateCode)}`
    );
  }

  createElectricUtilityProduct(product: ElectricUtilityProduct) {
    return this.post<ElectricUtilityProduct>(this.baseUrl, product);
  }

  updateElectricUtilityProduct(product: ElectricUtilityProduct) {
    return this.put<ElectricUtilityProduct>(
      `${this.baseUrl}/${encodeURIComponent(product.rateCode)}`,
      product
    );
  }

  deleteElectricUtilityProduct(rateCode: string) {
    return this.delete(`${this.baseUrl}/${encodeURIComponent(rateCode)}`);
  }
}
